'use client';

import React from 'react';
import { useEffect, useRef } from 'react';
import styled from 'styled-components';

export const Fps = () => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let lastCalledTime = Date.now();
    let fps = 0;
    function renderLoop() {
      const delta = (Date.now() - lastCalledTime) / 1000;
      lastCalledTime = Date.now();
      fps = 1 / delta;
      ref.current!.innerText = 'fps ' + fps.toFixed();
      requestAnimationFrame(renderLoop);
    }
    renderLoop();
  }, []);

  return <FpsRoot ref={ref} className="fps" />;
};

const FpsRoot = styled.div`
  position: fixed;
  top: 100px;
  left: 30px;
  color: red;
  font-family: monospace;
  font-size: 3.75em;
  z-index: 9999999;
`;
